import { render, staticRenderFns } from "./RptDtmCommission.vue?vue&type=template&id=2e2309d6&scoped=true&"
import script from "./RptDtmCommission.vue?vue&type=script&lang=js&"
export * from "./RptDtmCommission.vue?vue&type=script&lang=js&"
import style0 from "./RptDtmCommission.vue?vue&type=style&index=0&id=2e2309d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2309d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDataTable,VRow,VTextField})
